/* ps-template-20260813 — confetti + science-letter hook (additive; main.js untouched).
 * Subscribe success -> confetti + spec thank-you (locale string).
 * ?science-letter=1 -> force-open mailing popup, tag signup science-letter.
 * Cart-confirmation dialog open -> celebratory confetti (best-effort hook). */
(function () {
  'use strict';
  var fire = function (opts) { if (window.geroConfetti) window.geroConfetti(opts); };
  var colors = ['#7CC0FF', '#FFFFFF', '#C9D8FF', '#131A3E'];
  var dlg = document.querySelector('[data-mailing-popup]');
  var sci = /[?&]science-letter=1(&|$)/.test(window.location.search);
  if (dlg) {
    if (sci) {
      var tags = dlg.querySelector('input[name="contact[tags]"]');
      if (tags && tags.value.indexOf('science-letter') === -1) tags.value += ',science-letter';
      window.setTimeout(function () {
        if (dlg.open) return;
        try { if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); } catch (e) {}
      }, 400);
    }
    if (dlg.querySelector('[data-mailing-success]')) {
      window.setTimeout(function () { fire({ colors: colors }); }, 450);
    }
  }
  var cart = document.querySelector('[data-cart-confirmation]');
  if (cart && window.MutationObserver) {
    var last = 0;
    new MutationObserver(function () {
      if (cart.open && Date.now() - last > 4000) { last = Date.now(); fire({ colors: colors, count: 120 }); }
    }).observe(cart, { attributes: true, attributeFilter: ['open'] });
  }
})();
